/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { User } from './User';
import {
    UserFromJSON,
    UserFromJSONTyped,
    UserToJSON,
    UserToJSONTyped,
} from './User';
import type { UserMembershipSettings } from './UserMembershipSettings';
import {
    UserMembershipSettingsFromJSON,
    UserMembershipSettingsFromJSONTyped,
    UserMembershipSettingsToJSON,
    UserMembershipSettingsToJSONTyped,
} from './UserMembershipSettings';
import type { Permissions } from './Permissions';
import {
    PermissionsFromJSON,
    PermissionsFromJSONTyped,
    PermissionsToJSON,
    PermissionsToJSONTyped,
} from './Permissions';

/**
 * Serializer for retrieving user permissions and flags.
 * @export
 * @interface CompanyMembership
 */
export interface CompanyMembership {
    /**
     * 
     * @type {User}
     * @memberof CompanyMembership
     */
    readonly user: User;
    /**
     * 
     * @type {boolean}
     * @memberof CompanyMembership
     */
    readonly isStaff: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CompanyMembership
     */
    readonly isSuperuser: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CompanyMembership
     */
    readonly isTemporaryUser: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CompanyMembership
     */
    readonly viewAsCompany: boolean;
    /**
     * 
     * @type {number}
     * @memberof CompanyMembership
     */
    company: number;
    /**
     * 
     * @type {Permissions}
     * @memberof CompanyMembership
     */
    permissions: Permissions;
    /**
     * 
     * @type {UserMembershipSettings}
     * @memberof CompanyMembership
     */
    readonly settings: UserMembershipSettings;
    /**
     * 
     * @type {Array<string>}
     * @memberof CompanyMembership
     */
    readonly flags: Array<string>;
}

/**
 * Check if a given object implements the CompanyMembership interface.
 */
export function instanceOfCompanyMembership(value: object): value is CompanyMembership {
    if (!('user' in value) || value['user'] === undefined) return false;
    if ((!('isStaff' in (value as Record<string, any>)) && !('is_staff' in (value as Record<string, any>))) || ((value as Record<string, any>)['isStaff'] === undefined && (value as Record<string, any>)['is_staff'] === undefined)) return false;
    if ((!('isSuperuser' in (value as Record<string, any>)) && !('is_superuser' in (value as Record<string, any>))) || ((value as Record<string, any>)['isSuperuser'] === undefined && (value as Record<string, any>)['is_superuser'] === undefined)) return false;
    if ((!('isTemporaryUser' in (value as Record<string, any>)) && !('is_temporary_user' in (value as Record<string, any>))) || ((value as Record<string, any>)['isTemporaryUser'] === undefined && (value as Record<string, any>)['is_temporary_user'] === undefined)) return false;
    if ((!('viewAsCompany' in (value as Record<string, any>)) && !('view_as_company' in (value as Record<string, any>))) || ((value as Record<string, any>)['viewAsCompany'] === undefined && (value as Record<string, any>)['view_as_company'] === undefined)) return false;
    if (!('company' in value) || value['company'] === undefined) return false;
    if (!('permissions' in value) || value['permissions'] === undefined) return false;
    if (!('settings' in value) || value['settings'] === undefined) return false;
    if (!('flags' in value) || value['flags'] === undefined) return false;
    return true;
}

export function CompanyMembershipFromJSON(json: any): CompanyMembership {
    return CompanyMembershipFromJSONTyped(json, false);
}

export function CompanyMembershipFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompanyMembership {
    if (json == null) {
        return json;
    }
    return {
        
        'user': UserFromJSON(json['user']),
        'isStaff': json['is_staff'],
        'isSuperuser': json['is_superuser'],
        'isTemporaryUser': json['is_temporary_user'],
        'viewAsCompany': json['view_as_company'],
        'company': json['company'],
        'permissions': PermissionsFromJSON(json['permissions']),
        'settings': UserMembershipSettingsFromJSON(json['settings']),
        'flags': json['flags'],
    };
}

export function CompanyMembershipToJSON(json: any): CompanyMembership {
    return CompanyMembershipToJSONTyped(json, false);
}

export function CompanyMembershipToJSONTyped(value?: Omit<CompanyMembership, 'user'|'isStaff'|'isSuperuser'|'isTemporaryUser'|'viewAsCompany'|'settings'|'flags'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'company': value['company'],
        'permissions': PermissionsToJSON(value['permissions']),
    };
}

